<div class="p-seatmap__facility p-seatmap__col--{{ numberOfColumn }}col">
  <ng-container *ngFor="let code of codes">
    <!-- テーブル -->
    <div *ngIf="code === 'TA'" class="p-seatmap__table">
      <span class="u-visually-hidden" innerHTML="{{ 'm_static_message-label.table' | staticMsg }}"></span>
    </div>

    <!-- 化粧室 -->
    <img
      *ngIf="code === 'LA'"
      src="assets/images/seatmap_lavatory.svg"
      width="24"
      height="24"
      alt="{{ 'm_static_message-label.restroom' | staticMsg }}"
    />

    <!-- 多目的ルーム -->
    <img
      *ngIf="code === 'GF'"
      src="assets/images/seat_multi_purpose_room_24.svg"
      width="24"
      height="24"
      alt="{{ 'm_static_message-label.multipurposeRoom' | staticMsg }}"
    />

    <!-- ギャレー -->
    <img
      *ngIf="code === 'GN'"
      src="assets/images/seatmap_galley.svg"
      width="24"
      height="24"
      alt="{{ 'm_static_message-label.galley' | staticMsg }}"
    />

    <!-- バー -->
    <img
      *ngIf="code === 'BA'"
      src="assets/images/seatmap_bar.svg"
      width="24"
      height="24"
      alt="{{ 'm_static_message-label.barCounter' | staticMsg }}"
    />

    <!-- 階段 -->
    <img
      *ngIf="code === 'ST'"
      src="assets/images/seatmap_stair.svg"
      width="24"
      height="24"
      alt="{{ 'm_static_message-label.stairs' | staticMsg }}"
    />
  </ng-container>
</div>
